import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const deviceRoute = {
    SAVE_DEVICE: "dashboard/machine/devices/save",
    GET_COMPANY_DEVICES_LIST: "dashboard/machine/devices/get_company_devices",
    GET_MODULE_GROUPS: "dashboard/machine/devices/get_module_groups",
    GET_DEVICES_ACTIVED: "dashboard/machine/devices/get_device_activities",
    GET_LIST_DEVICCES: "dashboard/machine/devices/get_devices",
    GET_LIST_DEVICES_BILLING: "dashboard/machine/device/list/billing-devices",
    GET_LIST_DEVICES_BILLING_RANGE: "dashboard/machine/device/list/billing-range-date-devices",
    GET_LIST_PAYMENT_DEVICES: "dashboard/machine/device/list-payment-devices",
    GET_LIST_LANE_DEVICES: "dashboard/machine/device/list-lanes",
    GENERATE_LICENSE: "dashboard/machine/devices/generator-license",
};
export default {

    save(device) {
        return new Promise(resolve => {
            let code = -1;
            http.post(deviceRoute.SAVE_DEVICE, device)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se han guardado correctamente los cambios");
                        return;
                    }
                    toast.error("Error al guardar los permisos del dispositivo seleccionado");
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(code));
        });
    },

    getCompanyDevicesList(companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_COMPANY_DEVICES_LIST, {params: {companyId}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron dispositivos por compañia");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar dispositivos por compañia");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    getDeviceActivated(deviceId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_DEVICES_ACTIVED, {params: {deviceId}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron dispositivos activos");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar dispositivos activos");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    getModuleGroups(companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_MODULE_GROUPS, {params: {companyId}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron módulos por compañia");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los módulos por compañia");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    getListDevices() {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_LIST_DEVICCES)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron módulos por compañia");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los módulos por compañia");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }, listByResolution(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_LIST_DEVICES_BILLING, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron estaciones con resolución");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los estaciones");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }, listByBillingRange(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_LIST_DEVICES_BILLING_RANGE, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron estaciones con facturación");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los estaciones");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }, generateLicense(device) {
        return new Promise(resolve => {
            let code = -1;
            http.post(deviceRoute.GENERATE_LICENSE, device)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se han generado correctamente la licencia");
                        return;
                    }
                    toast.error("Error al generar la licencia del dispositivo seleccionado");
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(code));
        });
    }, /**
     * Lista dispositivos de pago o que tengan resolución de pago configurada
     * @param objParams criterios de búsqueda
     * @returns {Promise<unknown>}
     */
    listPaymentDevices(objParams) {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_LIST_PAYMENT_DEVICES, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron dispositivos de pago de esta compañía");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar los dispositivos de pago");
                        return;
                    }
                    const devices = data.info;
                    newData = data.info;
                    this.processOption(devices);
                    newData = devices;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    processOption(devices) {
        devices.forEach(value => {
                value.id = value.code;
                value.label = value.title;
                value.name = value.title;
            }
        );
    },
    listLanesByCompany(objParams){
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoute.GET_LIST_LANE_DEVICES, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron carriles de esta compañía");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar los carriles");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }
};